(() => {
  const bind = () => document.querySelectorAll('[data-ceika-page-navigation]').forEach(nav => {
    if(nav.dataset.navigationBound)return;
    nav.dataset.navigationBound='true';
    const links=[...nav.querySelectorAll('a[href^="#"]')];
    const targets=links.map(link=>document.getElementById(link.hash.slice(1)));
    const controller=new AbortController();
    let queued=false;
    const update=()=>{
      queued=false;
      const line=nav.getBoundingClientRect().height+30;
      let active=0;
      targets.forEach((target,i)=>{if(target&&target.getBoundingClientRect().top<=line)active=i;});
      links.forEach((link,i)=>{if(i===active)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    };
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
    window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
    window.addEventListener('resize',schedule,{passive:true,signal:controller.signal});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(nav))controller.abort();},{signal:controller.signal});
    update();
  });
  bind();
  document.addEventListener('shopify:section:load',bind);
})();
